import { render } from "./SurgeryChart.vue?vue&type=template&id=afba10c8"
import script from "./SurgeryChart.vue?vue&type=script&lang=js"
export * from "./SurgeryChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__